import { Card, Separator } from '@repo/shadcn';

import { useStockDetails } from '@/modules/stocks/stock-product-details/stock-product-details.hook';

export const ProductDetails = () => {
    const { data } = useStockDetails();

    return (
        <Card className={'space-y-4 p-4'}>
            <div className={'flex items-start justify-between'}>
                <h3 className={'text-lg font-semibold'}>{data?.data?.name}</h3>
                {/*<EditButton isIconButton={true} />*/}
            </div>
            <Separator />

            <div className={'space-y-2'}>
                <div>
                    <p className={'uppercase text-muted-foreground'}>Brand</p>
                    <p>{data?.data?.brand_name || 'N/A'}</p>
                </div>

                <div>
                    <p className={'uppercase text-muted-foreground'}>Generic</p>
                    <p>{data?.data?.generic_name || 'N/A'}</p>
                </div>

                <div className={'grid grid-cols-2'}>
                    <div>
                        <p className={'uppercase text-muted-foreground'}>
                            Strength
                        </p>
                        <p>{data?.data?.strength_name || 'N/A'}</p>
                    </div>

                    <div>
                        <p className={'uppercase text-muted-foreground'}>
                            Type
                        </p>
                        <p>{data?.data?.type_name || 'N/A'}</p>
                    </div>
                </div>

                <div>
                    <p className={'uppercase text-muted-foreground'}>
                        Alert Quantity
                    </p>
                    <p>{data?.data?.alert_quantity ?? 'N/A'}</p>
                </div>
            </div>
        </Card>
    );
};

ProductDetails.displayName = 'ProductDetails';
